import { Injectable, Injector } from "@angular/core";
import { SdkBase } from "../utilities/sdk-base/sdk.base";
import { Observable, catchError, of } from "rxjs";
import { DatMapMetadataModel } from '@models/resource/dat-map.resource';
import { FileUploadRequestPackageResource } from '@models/resource/file-upload-request-package.resource';
import { FileUploadResponsePackageResource } from '@models/resource/file-upload-response-package.resource';
import { DatFileUploadRequestResource } from '@models/resource/dat-file-upload-request.resource';

@Injectable({ providedIn: 'root' })
export class DatMapSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public getState(uploadBatchId: string): Observable<DatMapMetadataModel | null> {
		return this.makeHttpRequest<DatMapMetadataModel>('get', `api2/uploadBatches/${uploadBatchId}/datMap`).pipe(
			catchError(() => { return of(null); }));
	}

	public putState(uploadBatchId: string, datMapState: DatMapMetadataModel, runDatMap: boolean = true) {
		return this.makeHttpRequest<DatMapMetadataModel>('put', `api2/uploadBatches/${uploadBatchId}/datMap?runDatMap=${runDatMap}`, datMapState).pipe(
			catchError(() => { return of(null); }));
	}

	public requestDatUploadInstructions(uploadPackage: FileUploadRequestPackageResource): Observable<FileUploadResponsePackageResource> {
		const items = uploadPackage.requests.map((item) => {
			return {
				sourceFileName: item.fileName,
				fileSize: item.fileSize,
				contentType: item.contentType,
				sourceFilePath: item.filePath
			} as DatFileUploadRequestResource;
		});
		return this.makeHttpRequest<FileUploadResponsePackageResource>('post', `api2/uploadBatches/${uploadPackage.uploadBatchId}/datUploadInstructions`, {
			requests: items
		});
	}
}
